// @flow

import React , { Fragment } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { reset, change } from 'redux-form'
import { Map } from 'immutable'
import bindAll from "lodash/bindAll"
import UserRegisterWizardFormFirstPageNew from '../pages/users/UserRegisterWizardFormFirstPageNew'
import UserRegisterWizardFormThirdPageNew from '../pages/users/UserRegisterWizardFormThirdPageNew'
import { usersAddNavigationPage } from '../../actions/users'
import { UilTimes } from '@iconscout/react-unicons'
import Initializers from '../../dependencies/initializers'


import { usersResendVerificationEmailRequest } from '../../actions/users'
import {
	globalHideSweetAlert,
	globalAddSweetAlertData
} from '../../actions/global'

type Props = {
	isOpen: boolean,
	onRequestClose: Function,
	plan?: string,
	cdcId?: string,
	resetForm: Function,
	usersAddNavigationPage: Function,
	changeFieldValue: Function,
	usersNavigationData: Map<string, any>,
	globalGetLanguages: Map<string, any>,
	userTempEmail: Map<string, any>,
	usersResendVerificationEmailRequest: Function,
	globalHideSweetAlert: Function,
	globalAddSweetAlertData: Function
};

type State = {
	cachedUsersNavigationDataPage: string,
	option: any,
	setOption: Function,
	nextPage: Function,
	prevPage: Function
};

// Set the app element for accessibility
if (typeof document !== 'undefined') {
	Modal.setAppElement('#root')
}

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '614px',
		width: '90%',
		height: 'auto',
		maxHeight: '90vh',
		overflow: 'visible',
		padding: '0',
		border: 'none',
		borderRadius: '8px',
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
		position: 'relative'
	},
	overlay: {
		backgroundColor: 'rgba(51, 51, 51, 0.6)',
		zIndex: 1000,
		padding: '20px'
	}
}

class ModalRegister extends React.Component<Props, State> {
	constructor(props) {
		super(props)

		this.state = {
			cachedUsersNavigationDataPage: '',
			option: [],
			setOption: (val) => { this.setState({option: val}) },
			nextPage: () => {},
			prevPage: () => {}
		}

		bindAll(this, [
			"handleModalClose",
			"handleResendVerificationEmailClick"
		])
	}

	componentDidMount() {
		// Auto-fill CDC if present
		if(this.props.cdcId) {
			this.props.changeFieldValue('segment_type', "Career Development Center");
			this.setState({
				option: [{value: "Career Development Center", label: "Career Development Center", description:'Prepare students for successful careers. Measure student outcomes.'}]
			})
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const {
			usersNavigationData,
			usersAddNavigationPage
		} = nextProps

		if (usersNavigationData.get('page') !== prevState.cachedUsersNavigationDataPage) {
			let page: number = usersNavigationData.get('page')

			const nextPage: Function = () => {
				usersAddNavigationPage(page + 1)
			}

			const previousPage: Function = () => {
				usersAddNavigationPage(page - 1)
			}

			switch(page) {
				case 2:
					// Registration successful - show success page
					window.dataLayer && window.dataLayer.push({
						event: 'registered',
						page: {
						  title: 'registered success'
						}
					})
					return {
						cachedUsersNavigationDataPage: page,
					}
				default:
					return {
						cachedUsersNavigationDataPage: page,
						prevPage: previousPage,
						nextPage: nextPage,
					}
			}
		}

		return null
	}

	handleModalClose() {
		// Reset form and navigation when modal closes
		this.props.resetForm('UserRegisterWizardForm')
		this.props.usersAddNavigationPage(1)
		this.props.onRequestClose()
	}

	handleResendVerificationEmailClick(e) {
		e.preventDefault()

		const {
			userTempEmail,
			usersResendVerificationEmailRequest,
			globalHideSweetAlert,
			globalAddSweetAlertData
		} = this.props
		usersResendVerificationEmailRequest(userTempEmail.get('email'))
		.then(()=>{
			this.handleModalClose()
			globalAddSweetAlertData({
				show: true,
				title: 'Please Verify Your Email',
				text: "Your ASTRNT account has been successfully created. Check your email to confirm your account",
				confirmButtonText: 'OK',
				confirmButtonColor: '#564FDB',
				showLoaderOnConfirm: true,
				onConfirm: () => {
					globalHideSweetAlert()
					window.location = Initializers.api_host+'/auth/login'
				}
			})
		})
	}

	render() {
		const {
			isOpen,
			plan = 'free',
			cdcId = '',
			globalGetLanguages
		} = this.props

		const {
			cachedUsersNavigationDataPage,
			prevPage,
			nextPage,
			setOption,
			option
		} = this.state

		return (
			<Modal
				isOpen={isOpen}
				onRequestClose={this.handleModalClose}
				style={customStyles}
				contentLabel="Registration Modal"
				shouldCloseOnOverlayClick={true}
				shouldCloseOnEsc={true}
				className="modal-register"
			>
				<button
                    id="close-modal"
					onClick={this.handleModalClose}
					style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: 'auto',
						position: 'absolute',
						top: '15px',
						right: '15px',
						background: 'none',
						border: 'none',
						cursor: 'pointer',
						fontSize: '20px',
						color: '#666',
						zIndex: 1001,
						padding: '5px',
						borderRadius: '50%'
					}}
					aria-label="Close modal"
				>
					<UilTimes />
				</button>
				<div className="box-reg" style={{ margin: 0 }}>
					{
						cachedUsersNavigationDataPage == '2' ? 
							<Fragment>
								<div className="tit-reg tit-reg-verify">Please Verify Your Email</div>
								<div className="text-success-top text-center">
									<p>Your ASTRNT account has been successfully created. Check your email to confirm your account.</p>
								</div>
								<div className="center text-success-bottom">
									<p>If you can’t find the email, check your spam folder or</p>
									<div>
									<a className="btn-resend" onClick={this.handleResendVerificationEmailClick}>Resend Email.</a>
									</div>
								</div>
							</Fragment> 
							: 
							<UserRegisterWizardFormFirstPageNew
								previousPage={prevPage}
								setOption={setOption}
								option={option}
								plan={plan}
								cdcId={cdcId}
								isModal={true}
							/>
					}
				</div>
			</Modal>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		usersNavigationData: state.usersNavigationData,
		globalGetLanguages: state.globalGetLanguages,
		userTempEmail: state.userTempEmail
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		resetForm: (formName) => dispatch(reset(formName)),
		usersAddNavigationPage: (page) => dispatch(usersAddNavigationPage(page)),
		changeFieldValue: (field, value) => dispatch(change('UserRegisterWizardForm', field, value, true, true)),
		usersResendVerificationEmailRequest: (email) => dispatch(usersResendVerificationEmailRequest(email)),
		globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
		globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalRegister)